import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function usePersonalContactTypes() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.PERSONAL_CONTACT}/types/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
